export default __webpack_public_path__ + "static/hot-juice-f49ca6db4655dff00fa26a75077b66ac.png";